/**
 * Pull Up Stand - Blog Post Functions
 * Handles sharing, WhatsApp integration, and UI interactions
 */

// WhatsApp Share Function
function shareToWhatsApp() {
  try {
    // Get current page details
    const articleTitle = document.querySelector('.article-template__title')?.textContent?.trim() || 'Article';
    const currentUrl = window.location.href;
    const siteName = 'PullUpStand.com';
    
    // Create share message with emojis and formatting
    const shareMessage = `🔥 *${articleTitle}*\n\n` +
                        `Read the full article on printing & display solutions:\n${currentUrl}\n\n` +
                        `📞 *Need urgent printing assistance?*\n` +
                        `✅ Same day printing available\n` +
                        `✅ Premium quality guaranteed\n` +
                        `✅ Trusted since 2007\n\n` +
                        `🌐 *${siteName}* — Your Trusted Printing Partner`;
    
    // Encode message for URL
    const encodedMessage = encodeURIComponent(shareMessage);
    
    // Create WhatsApp URL
    const whatsappUrl = `https://wa.me/?text=${encodedMessage}`;
    
    // Open WhatsApp
    window.open(whatsappUrl, '_blank', 'noopener,noreferrer');
    
    // Track event if analytics available
    trackEvent('whatsapp_share_banner', 'click', articleTitle);
    
  } catch (error) {
    console.error('Error sharing to WhatsApp:', error);
    // Fallback to basic share
    const basicUrl = `https://wa.me/?text=${encodeURIComponent(window.location.href)}`;
    window.open(basicUrl, '_blank', 'noopener,noreferrer');
  }
}

// General Article Share Function
function shareArticle() {
  try {
    const articleTitle = document.querySelector('.article-template__title')?.textContent?.trim() || 'Article';
    const currentUrl = window.location.href;
    const siteName = 'PullUpStand.com';
    
    // Check if Web Share API is available
    if (navigator.share) {
      navigator.share({
        title: articleTitle,
        text: `Check out this article from ${siteName}:`,
        url: currentUrl
      }).then(() => {
        trackEvent('native_share', 'success', articleTitle);
      }).catch((error) => {
        console.log('Native share cancelled or failed:', error);
        fallbackShare();
      });
    } else {
      fallbackShare();
    }
    
    function fallbackShare() {
      // Fallback: Copy to clipboard
      const shareText = `${articleTitle}\n\nRead more: ${currentUrl}\n\nFrom ${siteName}`;
      
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(shareText).then(() => {
          showShareNotification('Link copied to clipboard!');
          trackEvent('clipboard_share', 'success', articleTitle);
        }).catch(() => {
          showShareOptions();
        });
      } else {
        showShareOptions();
      }
    }
    
    function showShareOptions() {
      // Create share modal or show options
      const shareOptions = [
        { name: 'WhatsApp', url: `https://wa.me/?text=${encodeURIComponent(`${articleTitle}\n${currentUrl}`)}` },
        { name: 'Telegram', url: `https://t.me/share/url?url=${encodeURIComponent(currentUrl)}&text=${encodeURIComponent(articleTitle)}` },
        { name: 'Facebook', url: `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(currentUrl)}` },
        { name: 'Twitter', url: `https://twitter.com/intent/tweet?url=${encodeURIComponent(currentUrl)}&text=${encodeURIComponent(articleTitle)}` }
      ];
      
      const modal = createShareModal(shareOptions);
      document.body.appendChild(modal);
    }
    
  } catch (error) {
    console.error('Error sharing article:', error);
    showShareNotification('Sharing not available');
  }
}

// Create share modal
function createShareModal(options) {
  const modal = document.createElement('div');
  modal.style.cssText = `
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0,0,0,0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 10000;
  `;
  
  const content = document.createElement('div');
  content.style.cssText = `
    background: white;
    padding: 2rem;
    border-radius: 8px;
    max-width: 400px;
    width: 90%;
    max-height: 80vh;
    overflow-y: auto;
  `;
  
  content.innerHTML = `
    <h3 style="margin-top: 0; color: var(--primary-blue);">Share Article</h3>
    <div style="display: grid; gap: 0.5rem;">
      ${options.map(option => `
        <a href="${option.url}" 
           target="_blank" 
           rel="noopener noreferrer"
           style="
             display: block;
             padding: 0.75rem 1rem;
             background: var(--background-neutral-light);
             color: var(--text-primary);
             text-decoration: none;
             border-radius: 4px;
             transition: background-color 0.2s;
           "
           onmouseover="this.style.backgroundColor='var(--light-accent-blue)'"
           onmouseout="this.style.backgroundColor='var(--background-neutral-light)'"
           onclick="trackEvent('social_share', '${option.name.toLowerCase()}', 'article'); setTimeout(() => modal.remove(), 100)">
          ${option.name}
        </a>
      `).join('')}
    </div>
    <button onclick="this.closest('div[style*=\"position: fixed\"]').remove()" 
            style="
              margin-top: 1rem;
              width: 100%;
              padding: 0.75rem;
              background: var(--cta-dark-blue-bg);
              color: white;
              border: none;
              border-radius: 4px;
              cursor: pointer;
            ">
      Close
    </button>
  `;
  
  modal.appendChild(content);
  
  // Close on backdrop click
  modal.addEventListener('click', (e) => {
    if (e.target === modal) modal.remove();
  });
  
  return modal;
}

// Show notification
function showShareNotification(message) {
  const notification = document.createElement('div');
  notification.style.cssText = `
    position: fixed;
    top: 20px;
    right: 20px;
    background: var(--cta-dark-blue-bg);
    color: white;
    padding: 1rem 1.5rem;
    border-radius: 4px;
    z-index: 10000;
    animation: slideIn 0.3s ease;
  `;
  notification.textContent = message;
  
  document.body.appendChild(notification);
  
  setTimeout(() => {
    notification.style.animation = 'slideOut 0.3s ease';
    setTimeout(() => notification.remove(), 300);
  }, 3000);
}

// Analytics tracking function
function trackEvent(action, label, value) {
  try {
    // Google Analytics 4
    if (typeof gtag !== 'undefined') {
      gtag('event', action, {
        'event_category': 'engagement',
        'event_label': label,
        'value': value
      });
    }
    
    // Facebook Pixel
    if (typeof fbq !== 'undefined') {
      fbq('track', 'Share', {
        content_name: value,
        content_category: 'article'
      });
    }
    
    // Custom analytics
    if (window.dataLayer) {
      window.dataLayer.push({
        'event': 'article_interaction',
        'interaction_type': action,
        'article_title': value
      });
    }
  } catch (error) {
    console.log('Analytics tracking error:', error);
  }
}

// Helper function to shuffle array
function shuffleArray(array) {
  for (let i = array.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [array[i], array[j]] = [array[j], array[i]];
  }
}

// Add dynamic styles
function addDynamicStyles() {
  const style = document.createElement('style');
  style.textContent = `
    @keyframes slideIn {
      from { transform: translateX(100%); opacity: 0; }
      to { transform: translateX(0); opacity: 1; }
    }
    @keyframes slideOut {
      from { transform: translateX(0); opacity: 1; }
      to { transform: translateX(100%); opacity: 0; }
    }
    @keyframes blink {
      0%, 50% { opacity: 1; }
      51%, 100% { opacity: 0.7; }
    }
    
    /* WhatsApp CTA Styling */
    .whatsapp-cta-inline {
      margin: 2.5rem auto;
      text-align: center;
      padding: 1rem 1.5rem;
      background: #f8fafc;
      border-radius: 12px;
      border: 1px solid #e2e8f0;
      max-width: 450px;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
      transition: all 0.3s ease;
    }
    
    .whatsapp-cta-inline:hover {
      transform: translateY(-2px);
      box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
      border-color: #25D366;
    }
    
    .whatsapp-cta-text {
      margin: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 12px;
      font-size: 0.95rem;
      animation: blink 3s infinite;
    }
    
    .whatsapp-cta-text a {
      color: #334155 !important;
      text-decoration: none;
      font-weight: 500;
      font-size: 0.95rem;
      transition: all 0.3s ease;
      letter-spacing: 0.01em;
    }
    
    .whatsapp-cta-text a:hover {
      color: #25D366 !important;
    }
    
    .whatsapp-cta-text svg {
      flex-shrink: 0;
      transition: all 0.3s ease;
    }
    
    .whatsapp-cta-inline:hover .whatsapp-cta-text svg {
      transform: scale(1.1);
    }
    
    /* Legal Disclaimer Styling */
    .article-disclaimer {
      margin: 3rem auto 2rem;
    }
    
    .disclaimer-box {
      background: #f8fafc;
      border: 1px solid #e2e8f0;
      border-radius: 12px;
      padding: 1.5rem 2rem;
      display: flex;
      gap: 1rem;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
      transition: all 0.3s ease;
    }
    
    .disclaimer-box:hover {
      border-color: #3b82f6;
      box-shadow: 0 4px 16px rgba(59, 130, 246, 0.1);
    }
    
    .disclaimer-icon {
      flex-shrink: 0;
      color: #3b82f6;
      margin-top: 0.25rem;
    }
    
    .disclaimer-content {
      flex: 1;
    }
    
    .disclaimer-title {
      margin: 0 0 0.75rem 0;
      font-size: 1.1rem;
      font-weight: 600;
      color: #1e40af;
      letter-spacing: -0.01em;
    }
    
    .disclaimer-text {
      margin: 0 0 0.75rem 0;
      font-size: 0.9rem;
      line-height: 1.6;
      color: #475569;
    }
    
    .disclaimer-text:last-of-type {
      margin-bottom: 0.5rem;
    }
    
    .disclaimer-text strong {
      color: #1e40af;
      font-weight: 600;
    }
    
    .disclaimer-copyright {
      margin: 0.75rem 0 0 0;
      font-size: 0.85rem;
      color: #64748b;
      border-top: 1px solid #e2e8f0;
      padding-top: 0.75rem;
    }
    
    .disclaimer-copyright strong {
      color: #1e40af;
      font-weight: 600;
    }
    
    /* Responsive adjustments */
    @media (max-width: 768px) {
      .whatsapp-cta-inline {
        margin: 2rem auto;
        padding: 0.875rem 1.25rem;
        max-width: 85%;
      }
      
      .whatsapp-cta-text {
        gap: 10px;
        font-size: 0.9rem;
      }
      
      .whatsapp-cta-text a {
        font-size: 0.9rem;
      }
      
      .whatsapp-cta-text svg {
        width: 18px;
        height: 18px;
      }
      
      .disclaimer-box {
        flex-direction: column;
        gap: 0.75rem;
        padding: 1.25rem 1.5rem;
      }
      
      .disclaimer-icon {
        align-self: flex-start;
      }
      
      .disclaimer-title {
        font-size: 1rem;
      }
      
      .disclaimer-text {
        font-size: 0.85rem;
      }
      
      .disclaimer-copyright {
        font-size: 0.8rem;
      }
    }
  `;
  document.head.appendChild(style);
}

// Initialize on DOM Ready
function initBlogPost() {
  // Assign IDs to each <h2> for TOC links
  const articleContent = document.querySelector('.article-template__content');
  if (articleContent) {
    const headings = articleContent.querySelectorAll('h2');
    headings.forEach((heading, idx) => {
      heading.id = `heading-${idx}`;
    });
  }
  
  // Shuffle and display 8 random articles
  const articlesContainer = document.getElementById('random-articles');
  if (articlesContainer) {
    const articleCards = Array.from(articlesContainer.children);
    shuffleArray(articleCards);
    articlesContainer.innerHTML = '';
    articleCards.slice(0, 8).forEach(card => articlesContainer.appendChild(card));
  }
  
  // Shuffle and display 12 random products
  const productsContainer = document.getElementById('random-products');
  if (productsContainer) {
    const productCards = Array.from(productsContainer.children);
    shuffleArray(productCards);
    productsContainer.innerHTML = '';
    productCards.slice(0, 12).forEach(card => productsContainer.appendChild(card));
  }
  
  // Add hover effects to square cards
  const squareCards = document.querySelectorAll('.square-card');
  squareCards.forEach(card => {
    card.addEventListener('mouseenter', function() {
      this.classList.add('square-card-hover');
    });
    card.addEventListener('mouseleave', function() {
      this.classList.remove('square-card-hover');
    });
  });
  
  // Add click tracking to WhatsApp banner
  const whatsappBanner = document.querySelector('.whatsapp-cta-banner');
  if (whatsappBanner) {
    whatsappBanner.addEventListener('click', function() {
      trackEvent('whatsapp_banner_click', 'sharing_container', 'article');
    });
  }
  
  // Add keyboard navigation support
  document.addEventListener('keydown', function(e) {
    // Escape key closes modals
    if (e.key === 'Escape') {
      const modals = document.querySelectorAll('div[style*="position: fixed"][style*="z-index: 10000"]');
      modals.forEach(modal => modal.remove());
    }
  });
  
  // Add dynamic styles
  addDynamicStyles();
  
  // Error handling for images
  const images = document.querySelectorAll('img');
  images.forEach(img => {
    img.addEventListener('error', function() {
      console.log('Image failed to load:', this.src);
      // You could set a placeholder image here
      // this.src = '/path/to/placeholder.jpg';
    });
  });
}

// Run initialization when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initBlogPost);
} else {
  initBlogPost();
}

/* =====================================================================
   PUS A11Y MODULE (Phase 6, 2026-07-06) — appended by SingRank.
   Runs AFTER the inline article script's DOMContentLoaded setup (that
   listener registers during parse, so it always fires first).
   1) FAQ: restores <h3> heading semantics; injects a real <button>
      (native keyboard support) and reuses the existing toggle handlers.
   2) Tables: wraps every body table in a scroll container and restores
      display:table on phones, so screen readers keep table semantics.
   No-JS fallback: the CSS display:block containment still applies.
   ===================================================================== */
function pusA11yUpgrade() {
  try {
    /* ---- 1. FAQ: real buttons inside headings ---- */
    document.querySelectorAll('.faq-item').forEach(function (item, i) {
      var q = item.querySelector('.faq-question');
      var a = item.querySelector('.faq-answer');
      if (!q || !a || q.querySelector('.faq-question__btn')) return;

      q.removeAttribute('role');
      q.removeAttribute('tabindex');
      var startOpen = q.classList.contains('active');
      q.removeAttribute('aria-expanded');

      if (!a.id) a.id = 'pus-faq-answer-' + (i + 1);

      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'faq-question__btn';
      btn.setAttribute('aria-controls', a.id);
      btn.setAttribute('aria-expanded', String(startOpen));
      while (q.firstChild) btn.appendChild(q.firstChild);
      q.appendChild(btn);

      /* native button converts Enter/Space into click; stop the keydown
         from reaching the legacy h3 handler so the toggle never doubles */
      btn.addEventListener('keydown', function (e) { e.stopPropagation(); });

      /* the legacy click handler (registered earlier) toggles .active and
         re-adds aria-expanded on the h3; this later listener moves the
         state onto the button and strips it from the heading */
      q.addEventListener('click', function () {
        btn.setAttribute('aria-expanded', String(q.classList.contains('active')));
        q.removeAttribute('aria-expanded');
      });
    });

    /* ---- 2. Tables: semantic scroll wrappers ---- */
    document.querySelectorAll('.article-template__content.rte table').forEach(function (t) {
      var p = t.parentElement;
      if (!p) return;
      if (p.classList.contains('pus-table-scroll') ||
          p.classList.contains('overflow-auto') ||
          p.classList.contains('overflow-x-auto')) return;
      var wrap = document.createElement('div');
      wrap.className = 'pus-table-scroll';
      p.insertBefore(wrap, t);
      wrap.appendChild(t);
    });

    /* ---- scoped styles for both fixes ---- */
    var s = document.createElement('style');
    s.textContent =
      '.faq-question__btn{all:unset;display:block;width:100%;cursor:pointer;font:inherit;color:inherit;letter-spacing:inherit;box-sizing:border-box;}' +
      '.faq-question__btn:focus-visible{outline:3px solid #0074c2;outline-offset:2px;border-radius:8px;}' +
      '.article-template__content.rte .pus-table-scroll{display:block;max-width:100%;overflow-x:auto;-webkit-overflow-scrolling:touch;border-radius:12px;margin:1.6em 0;}' +
      '.article-template__content.rte .pus-table-scroll>table{margin:0;}' +
      '@media (max-width:767px){.article-template__content.rte .pus-table-scroll>table,.article-template__content.rte .overflow-auto>table,.article-template__content.rte .overflow-x-auto>table{display:table;}}';
    document.head.appendChild(s);
  } catch (err) {
    console.log('PUS a11y upgrade error:', err);
  }
}

var pusA11yDone = false;
function pusA11yRunOnce() {
  if (pusA11yDone) return;
  pusA11yDone = true;
  pusA11yUpgrade();
}
if (document.readyState === 'complete') {
  pusA11yRunOnce();
} else {
  document.addEventListener('DOMContentLoaded', pusA11yRunOnce);
  window.addEventListener('load', pusA11yRunOnce);
}